import React, { useState } from 'react';
import MaterialIcon from '../ui/MaterialIcon';
import AirportSearchModal from './AirportSearchModal';

function FlightRouteCard({ origin, destination, onSwap, onOriginChange, onDestinationChange }) {
  const [showModal, setShowModal] = useState(false);
  const [modalField, setModalField] = useState('origin');

  const openModal = (field) => {
    setModalField(field);
    setShowModal(true);
  };

  const handleSelect = (airport) => {
    let value;
    if (airport.type === 'metro') {
      value = { type: 'metro', code: airport.code, city: airport.city, label: airport.label, airports: airport.airports };
    } else {
      value = { code: airport.iata, city: airport.city, country: airport.country, name: airport.name };
    }
    if (modalField === 'origin') {
      onOriginChange(value);
    } else {
      onDestinationChange(value);
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl p-5 shadow-card border border-outline-variant/10">
        <div className="flex items-center gap-3">
          {/* Origin */}
          <button onClick={() => openModal('origin')} className="flex-1 group text-left">
            <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label mb-1">From</p>
            <p className="text-3xl font-extrabold text-on-surface tracking-display group-hover:text-primary transition-colors">
              {origin.code}
            </p>
            <p className="text-sm text-on-surface-variant mt-0.5">{origin.city}</p>
            {origin.type === 'metro' ? (
              <p className="text-xs text-primary/80 font-medium">{origin.airports.length} airports</p>
            ) : origin.country ? (
              <p className="text-xs text-on-surface-variant/70">{origin.country}</p>
            ) : null}
          </button>

          {/* Swap Button */}
          <div className="flex flex-col items-center gap-1 pt-3">
            <button
              onClick={onSwap}
              className="w-10 h-10 rounded-full bg-primary-light/70 flex items-center justify-center hover:bg-primary hover:text-on-primary text-primary transition-all active:scale-95"
            >
              <MaterialIcon name="swap_horiz" size={22} />
            </button>
            <div className="flex items-center gap-1">
              <div className="w-3 h-px bg-outline-variant" />
              <MaterialIcon name="flight_takeoff" size={16} className="text-primary" />
              <div className="w-3 h-px bg-outline-variant" />
            </div>
          </div>

          {/* Destination */}
          <button onClick={() => openModal('destination')} className="flex-1 group text-right">
            <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label mb-1">To</p>
            <p className="text-3xl font-extrabold text-on-surface tracking-display group-hover:text-primary transition-colors">
              {destination.code}
            </p>
            <p className="text-sm text-on-surface-variant mt-0.5">{destination.city}</p>
            {destination.type === 'metro' ? (
              <p className="text-xs text-primary/80 font-medium">{destination.airports.length} airports</p>
            ) : destination.country ? (
              <p className="text-xs text-on-surface-variant/70">{destination.country}</p>
            ) : null}
          </button>
        </div>
      </div>

      <AirportSearchModal
        title={modalField === 'origin' ? 'Select Origin' : 'Select Destination'}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSelect={handleSelect}
      />
    </>
  );
}

export default FlightRouteCard;
